module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.booking_request_submitted) ? _c('div', [_c('h1', [_vm._v("Thank you!")]), _vm._v(" "), _c('h4', [_vm._v("Your booking request has been recieved.")])]) : (_vm.destination && (_vm.destination.trip_type == 1 || (_vm.destination.trip_type == 2 && _vm.trip))) ? _c('div', [_c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('div', {
    staticClass: "py-3 pl-3"
  }, [_c('h1', [_vm._v(_vm._s(_vm.destination.name))])]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v("ARRIVAL / DEPARTURE")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-form', {
    ref: "form_1",
    attrs: {
      "lazy-validation": "",
      "data-vv-scope": "form_1"
    },
    model: {
      value: (_vm.form_1_validation),
      callback: function($$v) {
        _vm.form_1_validation = $$v
      },
      expression: "form_1_validation"
    }
  }, [(_vm.destination.trip_type == 2 && _vm.trip) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-2": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('select-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "items": _vm.select_weeks,
      "v-errors": _vm.errors,
      "label": "Week",
      "name": 'week',
      "scope": 'form_1'
    },
    model: {
      value: (_vm.val_trip_week),
      callback: function($$v) {
        _vm.val_trip_week = $$v
      },
      expression: "val_trip_week"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-2": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('select-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "items": _vm.select_dates,
      "v-errors": _vm.errors,
      "label": "Date",
      "name": 'date',
      "scope": 'form_1'
    },
    model: {
      value: (_vm.val_trip_date),
      callback: function($$v) {
        _vm.val_trip_date = $$v
      },
      expression: "val_trip_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.val_trip_date == '999') ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-2": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialogfrom",
    attrs: {
      "return-value": _vm.form.date_from,
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.form, "date_from", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.form, "date_from", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Arrival date",
            "prepend-icon": "event",
            "readonly": "",
            "box": ""
          },
          model: {
            value: (_vm.form.date_from),
            callback: function($$v) {
              _vm.$set(_vm.form, "date_from", $$v)
            },
            expression: "form.date_from"
          }
        }, on))]
      }
    }], null, false, 1326304984),
    model: {
      value: (_vm.modal_date_from),
      callback: function($$v) {
        _vm.modal_date_from = $$v
      },
      expression: "modal_date_from"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.select_date_from_min,
      "max": _vm.select_date_from_max
    },
    model: {
      value: (_vm.form.date_from),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_from", $$v)
      },
      expression: "form.date_from"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal_date_from = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialogfrom.save(_vm.form.date_from)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialogto",
    attrs: {
      "return-value": _vm.form.date_to,
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.form, "date_to", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.form, "date_to", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Departure date",
            "prepend-icon": "event",
            "readonly": "",
            "box": ""
          },
          model: {
            value: (_vm.form.date_to),
            callback: function($$v) {
              _vm.$set(_vm.form, "date_to", $$v)
            },
            expression: "form.date_to"
          }
        }, on))]
      }
    }], null, false, 1154436370),
    model: {
      value: (_vm.modal_date_to),
      callback: function($$v) {
        _vm.modal_date_to = $$v
      },
      expression: "modal_date_to"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.select_date_to_min,
      "max": _vm.select_date_to_max
    },
    model: {
      value: (_vm.form.date_to),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_to", $$v)
      },
      expression: "form.date_to"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal_date_to = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialogto.save(_vm.form.date_to)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1) : (_vm.destination.trip_type == 1) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('select-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "items": _vm.select_trips,
      "v-errors": _vm.errors,
      "label": "Date",
      "name": 'date',
      "scope": 'form_1'
    },
    model: {
      value: (_vm.val_trip),
      callback: function($$v) {
        _vm.val_trip = $$v
      },
      expression: "val_trip"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v("GROUP")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-form', {
    ref: "form_2",
    attrs: {
      "lazy-validation": "",
      "data-vv-scope": "form_2"
    },
    model: {
      value: (_vm.form_2_validation),
      callback: function($$v) {
        _vm.form_2_validation = $$v
      },
      expression: "form_2_validation"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "light": ""
    },
    model: {
      value: (_vm.form.group_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "group_type", $$v)
      },
      expression: "form.group_type"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Open",
      "value": "1"
    }
  }), _vm._v(" "), (_vm.destination.trip_type == 2) ? _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Private",
      "value": "2"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 3,
      "step": "3"
    }
  }, [_vm._v("PARTICIPANTS")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-form', {
    ref: "form_3",
    attrs: {
      "lazy-validation": "",
      "data-vv-scope": "form_3"
    },
    model: {
      value: (_vm.form_3_validation),
      callback: function($$v) {
        _vm.form_3_validation = $$v
      },
      expression: "form_3_validation"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [1, 2, 3, 4, 5, 6],
      "box": "",
      "label": "Number of participants",
      "required": ""
    },
    model: {
      value: (_vm.val_num_participants),
      callback: function($$v) {
        _vm.val_num_participants = $$v
      },
      expression: "val_num_participants"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.form.participants), function(participant, n) {
    return _c('v-container', {
      key: n,
      attrs: {
        "fluid": "",
        "px-2": ""
      }
    }, [_c('v-divider'), _vm._v(" "), _c('p', {
      staticClass: "mt-2 font-weight-bold"
    }, [_vm._v("Participant " + _vm._s(parseInt(n) + 1))]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "d-flex": ""
      }
    }, [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-lg": "",
        "pa-0": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('text-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "form": _vm.form,
        "label": _vm.$t('name_first'),
        "v-errors": _vm.errors,
        "value": _vm.form.participants[n].name_first,
        "name": 'First name' + parseInt(n) + 1,
        "scope": 'form_3'
      },
      on: {
        "update:value": function($event) {
          return _vm.$set(_vm.form.participants[n], "name_first", $event)
        }
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('text-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "form": _vm.form,
        "label": _vm.$t('name_last'),
        "v-errors": _vm.errors,
        "value": _vm.form.participants[n].name_last,
        "name": 'Last name' + parseInt(n) + 1,
        "scope": 'form_3'
      },
      on: {
        "update:value": function($event) {
          return _vm.$set(_vm.form.participants[n], "name_last", $event)
        }
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('email-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|email'),
        expression: "'required|email'"
      }],
      attrs: {
        "form": _vm.form,
        "label": _vm.$t('email'),
        "v-errors": _vm.errors,
        "value": _vm.form.participants[n].email,
        "name": 'Email' + parseInt(n) + 1,
        "scope": 'form_3',
        "box": ""
      },
      on: {
        "update:value": function($event) {
          return _vm.$set(_vm.form.participants[n], "email", $event)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 4,
      "step": "4"
    }
  }, [_vm._v("SUMMARY")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-form', {
    ref: "form_4",
    attrs: {
      "lazy-validation": "",
      "data-vv-scope": "form_4"
    },
    model: {
      value: (_vm.form_4_validation),
      callback: function($$v) {
        _vm.form_4_validation = $$v
      },
      expression: "form_4_validation"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "pa-0": "",
      "mb-5": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.destination.name))]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Arrival date: ")]), _vm._v(_vm._s(_vm.form.date_from))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Departure date: ")]), _vm._v(_vm._s(_vm.form.date_to))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Group: ")]), _vm._v(_vm._s((_vm.form.group_type == 2 ? 'Private' : 'Open')))]), _vm._v(" "), _c('h4', [_vm._v("Participants")]), _vm._v(" "), _vm._l((_vm.form.participants), function(participant, p_index) {
    return _c('p', {
      key: p_index,
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(participant.name_first) + " " + _vm._s(participant.name_last) + " - " + _vm._s(participant.email))])
  }), _vm._v(" "), _c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Estimated Price")]), _vm._v(" "), (_vm.trip_price && _vm.trip_price.length > 0 && _vm.trip_price[0].amount_total_incl_vat) ? _c('div', [_c('p', [_vm._v("From " + _vm._s(_vm.trip_price[0].amount_total_incl_vat) + " EUR*")]), _vm._v(" "), _c('p', [_vm._v("*Rental gear and trip upgrades is not included in the estimated price.")])]) : _c('p', [_vm._v("The price cannot be estimated. Send in your booking request and we will contact you as soon as possible with the price.")])], 2)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_first'),
      "v-errors": _vm.errors,
      "scope": 'form_4',
      "value": _vm.form.customer_name_first,
      "name": 'First name'
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "customer_name_first", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_last'),
      "v-errors": _vm.errors,
      "scope": 'form_4',
      "value": _vm.form.customer_name_last,
      "name": 'Last name',
      "solo": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "customer_name_last", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('email-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('email'),
      "v-errors": _vm.errors,
      "scope": 'form_4',
      "value": _vm.form.customer_email,
      "name": 'Email',
      "box": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "customer_email", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.submit_request
    }
  }, [_vm._v(_vm._s(_vm.$t('send_booking_request')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = _vm.e1 - 1
      }
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1) : (_vm.data_fetched) ? _c('div', [_c('h1', [_vm._v("Sorry!")]), _vm._v(" "), _c('h4', [_vm._v("This trip is no longer available or currently not open for bookings.")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23be3564","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/booking/request.vue
// module id = xMqV
// module chunks = 1